import firebase from 'firebase/compat/app';
import STORE_CONSTANTS from '../constants';

const reportScheduleConverter = {
  toFirestore(
    schedule: ReportSchedules.Schedule,
  ): firebase.firestore.DocumentData {
    return { ...schedule };
  },
  fromFirestore(
    snapshot: firebase.firestore.QueryDocumentSnapshot,
    options: firebase.firestore.SnapshotOptions,
  ): ReportSchedules.Schedule {
    return snapshot.data(options) as ReportSchedules.Schedule;
  },
};

const getReportSchedulesRef = ({
  accountId,
  db,
}: {
  accountId: string;
  db?: firebase.firestore.Firestore;
}) => {
  return (db ? db : firebase.firestore())
    .collection('accounts')
    .doc(accountId)
    .collection(STORE_CONSTANTS.REPORT_SCHEDULES_COLLECTION)
    .withConverter(reportScheduleConverter);
};

export default getReportSchedulesRef;
